<template>
    <div class="insight-data-landing-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Salestracker Industry CRM in partnership with Insight Data
                </div>
                <div class="logo">
                    <img src="/images/insight-data-logo-small.png">
                </div>
            </div>
            <div class="box-1">
                <h1 style="max-width:750px;" class="ml-a mr-a">Get 15% discount for annual payment, or 12 months for the price of 10 for monthly payment options.</h1>
              <p>
                Scale your business much faster with Insight Data’s highly targeted, accurate business data and instantly pinpoint your perfect customers.
              </p>
              <p>
                Updated live in real-time to help your business drive sales, marketing and customer support, simply log in to Salestracker, and select the data you need:
              </p>
              <p>
                  Fabricators, installers, glass companies and trade-counters.<br>
                  Local builders specialising in new-build, refurbishment and extensions.<br>
                  Construction firms and major house-builders buying in large volumes.<br>
                  Builders merchants distributing to tens of thousands of customers.<br>
                  Architects and designers active in the UK build environment.
              </p>
            </div>
            <div class="overlapping-image">
                <img src="/images/offers-and-promotions-salestracker-industry-crm-header.png">
            </div>
            <div class="box-2">
                <p>
                  Insight Data’s Salestracker platform is perfect for remote working, shared customer information, document storage, tasks, lead management and reporting.
                </p>
                <p>
                    <a class="btn-primary-outline _lg" @click.prevent="enquiry_box_open = true">
                        Make Enquiry
                    </a>
                </p>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Salestracker Industry CRM Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like some more information on Salestracker Industry CRM',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 34,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Salestracker Industry CRM enquiry',
                'value': 'Salestracker Industry CRM enquiry',
              });

              this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - Insight Data Salestracker Industry CRM`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'Insight Data Salestracker Industry CRM partner link clicked',
          'value': 'Insight Data Salestracker Industry CRM partner link clicked',
        });
      },
    },
};
</script>
